import { usePrefs } from "@/context/PrefsContext";

const RE = /\[([^[\]|]+)\|([^[\]|]+)\|(N[1-5])\]/g;
const HARD = ["N3", "N2", "N1"];

export function plainJP(text = "") {
  return text.replace(RE, "$1");
}

export function renderJP(text = "", mode = "selective") {
  const re = new RegExp(RE.source, "g");
  const parts = [];
  let last = 0, m, i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const show = mode === "all" || (mode === "selective" && HARD.includes(m[3]));
    parts.push(show ? <ruby key={i++}>{m[1]}<rt>{m[2]}</rt></ruby> : m[1]);
    last = re.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export function JP({ text, mode, className = "", as: Tag = "span", serif = false, ...rest }) {
  const { prefs } = usePrefs();
  return (
    <Tag lang="ja" className={`${serif ? "jp-serif" : "jp"} ${className}`} {...rest}>
      {renderJP(text, mode || prefs.furigana)}
    </Tag>
  );
}
